import {Directive, HostListener, ElementRef, Output, EventEmitter} from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})

export class ClickOutsideDirective {

  @Output()
  clickOutside = new EventEmitter<MouseEvent>();

  constructor(
    private _ele: ElementRef
  ) { }

  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event, targetElement): void {
    if (!targetElement) {
      return;
    }
    const clickedInside = this._ele.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit(event);
    }
  }

  @HostListener('document:touchstart', ['$event', '$event.target'])
  onTouch(event, targetElement): void {

    if (!targetElement) {
      return;
    }
    const clickedInside = this._ele.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit(event);
    }
  }
}
